import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiqCommonModule } from '../../common/common-module';
import { ReportDetailsComponent } from './report-details.component';
import { ShowReportDetailsDirective } from './report-details.directive';

/**
 * Shared module for ReportDetailsComponent and ShowReportDetailsDirective.
 * Used by WorkspaceCategoryComponent (home page, AppModule)
 * and by ReportCatalogModule (/reports page).
 */
@NgModule({
  declarations: [
    ReportDetailsComponent,
    ShowReportDetailsDirective,
  ],
  imports: [
    CommonModule,
    GiqCommonModule,
  ],
  exports: [
    ReportDetailsComponent,
    ShowReportDetailsDirective,
  ],
})
export class ReportDetailsSharedModule {}
